import type { PlayerView } from './PlayerViewSchema'

export type StagedMove = { from: number; to: number } | null
type Board = PlayerView['board']

function isReal(m: StagedMove): m is { from: number; to: number } {
  return m !== null && m.from >= 0 && m.to >= 0 && m.from !== m.to
}

/** Optimistic overlay: relocate the piece from->to, empty the source, drop any
 *  captured opponent piece at the target. Returns a new board (input untouched). */
export function applyStagedMove(board: Board, move: StagedMove): Board {
  if (!isReal(move)) return board
  const src = board.find((c) => c.cell_idx === move.from)
  if (!src || src.piece_owner_slot === null) return board
  return board.map((c) => {
    if (c.cell_idx === move.from) {
      return { ...c, piece_owner_slot: null, piece_kind: null, role_kind: null }
    }
    if (c.cell_idx === move.to) {
      return {
        ...c,
        piece_owner_slot: src.piece_owner_slot,
        piece_kind: src.piece_kind,
        role_kind: src.role_kind,
      }
    }
    return c
  })
}

/** When a staged move exists and the pressed cell is its target, the previewed
 *  piece is a proxy for the original source — re-pick that source. */
export function resolveDragSource(
  pressedCellIdx: number,
  move: StagedMove,
): number {
  if (isReal(move) && pressedCellIdx === move.to) return move.from
  return pressedCellIdx
}
